import FlowPageContainer from './FlowPageContainer';
export default FlowPageContainer;
